module.exports = __webpack_public_path__ + "img/Dantam Bridal 01.774e652e.jpg";